import Vue from "vue";

import { Component, Prop, Watch } from "@/decorators";

import "./filepicker.scss";

@Component
export default class FilePickerComponent extends Vue {
    @Prop(String) id: string;
    @Prop(String) name: string;
    @Prop(File) value: File;
    @Prop(Boolean) disabled: boolean;
    @Prop({ type: Boolean, default: false }) multiple: boolean;
    @Prop({ type: String, default: "Clique aqui para selecionar o arquivo" }) text: string;

    selectedCount = 0;

    private onFileChanged(event) {
        if (this.multiple) {
            this.selectedCount = event.target.files.length;
            this.$emit("files-selected", event.target.files);
        } else {
            this.$emit("input", event.target.files[0]);
        }
    }

    public clear() {
        this.selectedCount = 0;
        const input = this.$el.querySelector("input[type='file']") as HTMLInputElement;
        if (input) {
            input.value = "";
        }
    }

    @Watch("value")
    private onValueChanged() {
        if (!this.value) {
            (this.$el.querySelector("input[type='file']") as HTMLInputElement).value = "";
        }
    }
}
